<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tocchaptitle"><a id="contents"></a>Contents</h1>
<p style="text-align:center; margin-top:0.75pc"></p>
<p class="center"><img alt="Image" src="images/pvi-01.jpg"/></p>
<p style="text-align:center; margin-top:0.75pc"></p>
<p class="toc"><a href="#/05_introduction#intro">Introduction</a></p>
<p class="toc"><a href="#/06_fall#fall">Fall</a></p>
<p class="toc"><span href="#/07_winter#winter" title="Link target outside of Sample">Winter</span></p>
<p class="toc"><span href="#/08_spring#spring" title="Link target outside of Sample">Spring</span></p>
<p class="toc"><span href="#/09_summer#summer" title="Link target outside of Sample">Summer</span></p>
<p class="toc"><span href="#/10_index#index" title="Link target outside of Sample">Index</span></p>
<p class="toc"><span href="#/11_acknowledgments#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc"><span href="#/12_copyrightacknowledgments#copyack" title="Link target outside of Sample">Copyright Acknowledgments</span></p>
<p class="toc"><span href="#/13_abouttheauthor#ata" title="Link target outside of Sample">About the Editor</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_contents.vue?34262b68